import React, { useState } from 'react';
import { PlugFill } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';
import PrimaryButton from './PrimaryButton';
import ConnectBrokerModal from '../broker/ConnectBrokerModal';

/**
 * Simple "no broker connected" empty state with a CTA that opens the existing
 * ConnectBrokerModal. Mirrors the trade-page chart overlay so the Dashboard and
 * Performance surfaces show a consistent prompt when no broker is linked.
 */
export default function BrokerNotConnectedState({
  title = 'No broker connected',
  message = 'Link TradeStation Direct or Connect Trade for live data and account performance.',
  minHeight = 220,
  style,
}) {
  const { colors } = useTheme();
  const [showConnect, setShowConnect] = useState(false);

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 14,
          minHeight,
          padding: '32px 24px',
          borderRadius: 16,
          border: `1px solid ${colors.borderLight}`,
          background:
            'linear-gradient(135deg, rgba(139, 92, 246, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%)',
          ...style,
        }}
      >
        <h3
          style={{
            fontSize: '1.25rem',
            fontWeight: 600,
            margin: 0,
            color: colors.text,
            letterSpacing: '-0.01em',
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontSize: '0.95rem',
            color: colors.textSecondary,
            margin: 0,
            maxWidth: 420,
            lineHeight: 1.5,
            opacity: 0.9,
          }}
        >
          {message}
        </p>
        <PrimaryButton onClick={() => setShowConnect(true)}>
          <PlugFill size={16} />
          Connect broker
        </PrimaryButton>
      </div>

      <ConnectBrokerModal show={showConnect} onHide={() => setShowConnect(false)} />
    </>
  );
}
